module.exports = __webpack_public_path__ + "img/acounto_logo-06n.100bc751.svg";